import { authorizationComponent } from './authorization.component';
import { ticketStateName } from '../../ticket.state';

export const authorizationStateName = `${ticketStateName}.authorization`;

export const authorizationState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: authorizationStateName,
    url: '/authorization',
    component: authorizationComponent.name,
    resolve: {
      maybeRedirectToNewUi: (appConfig, $window, envService) => {
        const { ui } = appConfig;
        if (ui.v2UI.oldBank && !envService.isLocalhost()) {
          $window.location.href = $window.location.href.replace(
            '/tickets',
            '/v2/tickets',
          );
        }
      },
    },
    data: { requiresAuth: true },
  });
};
